// extracted by mini-css-extract-plugin
export var activeDot = "_3g-c";
export var buttonContainer = "_3g-9";
export var channelButton = "_3g-a";
export var clickable = "_3g-d";
export var content = "_3g-0";
export var contentFull = "_3g-2";
export var contentThird = "_3g-1";
export var contentWrapper = "_3g-7";
export var description = "_3g-5";
export var heightShort = "_3g-f";
export var image = "_3g-3";
export var imageContainer = "_3g-4";
export var selectButton = "_3g-e";
export var spinnerContainer = "_3g-b";
export var titleContent = "_3g-8";
export var titleWrapper = "_3g-6";